  (function() {
    var lastCartToken = '';

    function fetchUpsells() {
      var container = document.getElementById('cart-drawer-upsell');
      var productsContainer = document.getElementById('cart-drawer-upsell-products');
      if (!container || !productsContainer) return;

      fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!cart.items.length) {
            container.style.display = 'none';
            return;
          }

          var token = cart.items.map(function(i) { return i.product_id + ':' +
  i.quantity; }).join(',');
          if (token === lastCartToken) return;
          lastCartToken = token;

          var inCartIds = cart.items.map(function(i) { return i.product_id; });
          var allRecs = [];
          var seen = {};

          var fetches = cart.items.map(function(item) {
            return fetch('/recommendations/products.json?product_id=' + item.product_id +
   '&limit=4&intent=complementary')
              .then(function(r) { return r.json(); })
              .then(function(data) {
                if (data.products) {
                  data.products.forEach(function(p) {
                    if (inCartIds.indexOf(p.id) === -1 && !seen[p.id] && p.available) {
                      seen[p.id] = true;
                      allRecs.push(p);
                    }
                  });
                }
              })
              .catch(function() {});
          });

          Promise.all(fetches).then(function() {
            renderUpsells(allRecs.slice(0, 2), container, productsContainer);
          });
        });
    }

    function renderUpsells(products, container, productsContainer) {
      if (!products.length) {
        container.style.display = 'none';
        return;
      }

      productsContainer.innerHTML = '';

      products.forEach(function(product) {
        var variant = product.variants[0];
        var price = (variant.price / 100).toFixed(2);
        var comparePrice = variant.compare_at_price ? (variant.compare_at_price /
  100).toFixed(2) : null;
        var image = product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/,
   '_200x$1') : '';

        var html = '<div class="cart-drawer-upsell__product">' +
          '<img class="cart-drawer-upsell__product-image" src="' + image + '" alt="' +
  product.title + '" loading="lazy">' +
          '<div class="cart-drawer-upsell__product-info">' +
          '<p class="cart-drawer-upsell__product-title">' + product.title + '</p>' +
          '<p class="cart-drawer-upsell__product-price">' +
          '\u20AC' + price +
          (comparePrice ? ' <span class="compare-price">\u20AC' + comparePrice +
  '</span>' : '') +
          '</p>' +
          '<button class="cart-drawer-upsell__add-btn" data-variant-id="' + variant.id +
  '">Add to cart</button>' +
          '</div></div>';

        productsContainer.insertAdjacentHTML('beforeend', html);
      });

      container.style.display = 'block';

      productsContainer.querySelectorAll('.cart-drawer-upsell__add-btn').forEach(function
  (btn) {
        btn.addEventListener('click', function() {
          var variantId = parseInt(btn.dataset.variantId);
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(function(r) { return r.json(); })

         .then(function() {
            btn.textContent = 'Added \u2713';
            btn.disabled = true;
            lastCartToken = '';
            // Trigger Dawn's cart refresh
            var cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems && cartDrawerItems.onCartUpdate) {
              cartDrawerItems.onCartUpdate();
            } else {
              // Fallback: fetch updated drawer HTML
              fetch(window.location.pathname + '?sections=cart-drawer')
                .then(function(r) { return r.json(); })
                .then(function(sections) {
                  if (sections['cart-drawer']) {
                    var temp = document.createElement('div');
                    temp.innerHTML = sections['cart-drawer'];
                    var newItems = temp.querySelector('#CartDrawer-CartItems');
                    var newFooter = temp.querySelector('.cart-drawer__footer');
                    var oldItems = document.getElementById('CartDrawer-CartItems');
                    var oldFooter = document.querySelector('.cart-drawer__footer');
                    if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;
                    if (newFooter && oldFooter) oldFooter.innerHTML =
  newFooter.innerHTML;
                    // Update cart count
                    var newBubble = temp.querySelector('.cart-count-bubble');
                    var oldBubble = document.querySelector('.cart-count-bubble');
                    if (newBubble && oldBubble) oldBubble.innerHTML =
  newBubble.innerHTML;
                    setTimeout(fetchUpsells, 300);
                  }
                });
            }
          })

          .catch(function() {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
        });
      });
    }

    fetchUpsells();

    setInterval(function() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('is-empty') === false) {
        if (document.getElementById('cart-drawer-upsell')) {
          fetchUpsells();
        }
      }
    }, 3000);
  })();